// removed by extract-text-webpack-plugin
module.exports = {"listImg":"_1WFj3wkqZo7yJtwslwq6sv","content":"LsAMrsxOpCMP4MdhG8zzk","placeholder":"_2wqlAdQIxTKC0PX32JtUpt","postTitle":"tfNsS71lBbKjE1_4ykJWR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/post-related-item/PostRelatedItem.css
// module id = 555
// module chunks = 0